import { Component } from '@angular/core';
import { NavController, LoadingController } from 'ionic-angular';
import { Globals } from '../../../globals';
import { SchoolServices } from '../services';
import { ClassroomsStudentsListPage } from '../classrooms-students-list/classrooms-students-list';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'page-home-teacher',
    templateUrl: 'home-teacher.html'
})

export class HomeTeacherPage {

    classrooms: any;
    constructor(public navCtrl: NavController,
        public globals: Globals,
        public schoolServices: SchoolServices,
        public loadingCtrl: LoadingController,
        public translate: TranslateService) {

        this.getClassrooms();

    }

    async getClassrooms() {
        let loadingPopup = this.loadingCtrl.create({
            spinner: 'crescent',
            content: this.translate.instant('instant-cargando-cursos')
        });
        loadingPopup.present();
        this.classrooms = await this.schoolServices.getClassroomsOfTeacher(this.globals.school_uid);
        loadingPopup.dismiss();
    }


    openClassroom(classroom) {
        this.navCtrl.push(ClassroomsStudentsListPage, {
            classroom: classroom
        });
    }
}



// WEBPACK FOOTER //
// ./src/pages/schools/home-teacher/home-teacher.ts